//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const GRID_MEDIA_HEIGHT = 245;
export const GRID_MEDIA_WIDTH = 224;

export const GRID_MAX_DISPLAY_ITEMS = 8;
